import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { galleryLayout5Style } from '@components/gallery/components/gallery-layout-5/config';
import { GalleryLayout5, GalleryLayout5Style } from '@components/gallery/components/gallery-layout-5/model';
import { IsShowCtaPipe } from '@components/gallery/components/gallery-layout-5/pipe';
import { MiddleOfficeService } from '@services/middle-office';
import { ResponsiveService } from '@services/responsive';
import { ButtonComponent } from '@shared/components/button';
import { ImageComponent } from '@shared/components/image';
import { MiddleOfficeButtonComponent } from '@shared/components/middle-office-button';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';
import { VideoComponent } from '@shared/components/video';
import { AddClassOnViewDirective } from '@shared/directives';
import { ColorPipe } from '@shared/pipes';

@Component({
  selector: 'app-gallery-layout-5',
  imports: [
    AsyncPipe,
    NgClass,
    NgTemplateOutlet,
    TitleComponent,
    MiddleOfficeButtonComponent,
    ColorPipe,
    AddClassOnViewDirective,
    RouterLink,
    ButtonComponent,
    IsShowCtaPipe,
    ImageComponent,
    VideoComponent,
  ],
  templateUrl: './gallery-layout-5.component.html',
  styleUrl: './gallery-layout-5.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryLayout5Component implements OnInit {
  readonly data = input.required<GalleryLayout5>();
  readonly isMiddleOfficeToken$ = inject(MiddleOfficeService).isMiddleOfficeToken$();
  readonly breakpoints = inject(ResponsiveService).breakpoints;
  title = signal<Title>(null!);
  subtitle = signal<Title>(null!);
  style = signal<GalleryLayout5Style>(null!);

  ngOnInit(): void {
    this.style.set(galleryLayout5Style[this.data().theme]!);
    this.title.set({
      level: 'H2',
      size: {
        mobile: 'H3',
        desktop: 'H3',
      },
      font: 'IVY_MODE',
      color: 'BLACK',
      align: {
        mobile: 'LEFT',
        desktop: 'LEFT',
      },
      text: this.data().title,
    });
    this.subtitle.set({
      level: 'SPAN',
      type: 'SLASH',
      size: {
        mobile: 'SPAN',
        desktop: 'SPAN',
      },
      weight: 500,
      color: 'GREY_LIGHT',
      align: {
        mobile: 'LEFT',
        desktop: 'LEFT',
      },
      text: this.data().subtitle,
    });
  }
}
